import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Anchor, Zap, Trophy, Timer, Waves, Sunrise } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function SurfskiPage() {
  useEffect(() => {
    // Set meta tags for Surfski page
    document.title = "קיאק Surfski | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'חתירה בקיאק Surfski בכנרת - מהירות, אדרנלין וטכניקה או חתירה רגועה ונופי הכנרת. הדרכות וקבוצות אימון');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "קיאק Surfski | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'חתירה בקיאק Surfski בכנרת - מהירות ואדרנלין או חתירה רגועה. הדרכות אישיות וקבוצות אימון'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "קיאק Surfski | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'חתירה בקיאק Surfski בכנרת - מהירות ואדרנלין'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1290">
      <Navigation data-id="element-1291" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-1292">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-1293" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png" alt="Surfski Activity" className="w-full h-full object-cover" data-id="element-1294" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-1295">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-1296">
            קיאק Surfski
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-1297">
            מהירות, אדרנלין וטכניקה על המים - או סתם חתירה רגועה ונופי הכנרת
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-1298">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1299">
          <div data-id="element-1300">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-1301">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-1302">
              ה-Surfski הוא קיאק פתוח, צר וארוך, המיועד לחתירה מהירה ולגלישת
              גלים (Downwind). זהו ספורט המשלב כושר גופני אירובי ברמה גבוהה עם
              מיומנות טכנית של קריאת הים ותפיסת גלים. במועדון שלנו תמצאו את
              הקיאקים הטובים בעולם מבית המותגים המובילים.
            </p>

            {/* Relaxed Paddling Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-2xl p-6 mb-8" data-id="element-1303">
              <div className="flex items-start gap-4" data-id="element-1304">
                <div className="bg-white p-3 rounded-xl shadow-sm" data-id="element-1305">
                  <Sunrise className="w-6 h-6 text-blue-500" data-id="element-1306" />
                </div>
                <div data-id="element-1307">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1308">
                    חתירה רגועה ונופי הכנרת
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-1309">
                    לא חייבים להיות ספורטיביים! הקיאק מושלם גם לחתירה רגועה
                    ונינוחה על מי הכנרת השקטים. תיהנו מהשקט, מהנוף המדהים של
                    ההרים מסביב, ומחוויה מדיטטיבית של חיבור לטבע. מתאים במיוחד
                    לזריחות ושקיעות קסומות.
                  </p>
                </div>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1310">
              למי זה מתאים?
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-1311">
              {['חותרים המחפשים אתגר פיזי ומנטלי', 'אוהבי אדרנלין ומהירות', 'מי שרוצה חתירה רגועה ולהנות מנופי הכנרת', 'מי שרק בא לו להרגע ולהתנתק מהשגרה', 'אנשים עם רקע בחתירה (אך לא חובה, יש קורסי מתחילים)', 'מי שרוצה לשפר את הכושר האירובי בצורה משמעותית'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-1312">
                  <div className="bg-indigo-100 p-1 rounded-full" data-id="element-1313">
                    <Zap className="w-4 h-4 text-indigo-600" data-id="element-1314" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-1315">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-1316">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-1317">
              <div className="flex gap-4" data-id="element-1318">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1319">
                  <Anchor className="w-6 h-6 text-indigo-500" data-id="element-1320" />
                </div>
                <div data-id="element-1321">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1322">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1323">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד חותרים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1324">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1325">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-1326" />
                </div>
                <div data-id="element-1327">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1328">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1329">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1330">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1331">
                  <Zap className="w-6 h-6 text-indigo-500" data-id="element-1332" />
                </div>
                <div data-id="element-1333">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1334">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1335">
                    הצטרפו לקהילת חותרים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1336">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1337">
                  <Trophy className="w-6 h-6 text-indigo-500" data-id="element-1338" />
                </div>
                <div data-id="element-1339">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1340">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1341">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1342">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1343">
                  <Timer className="w-6 h-6 text-indigo-500" data-id="element-1344" />
                </div>
                <div data-id="element-1345">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1346">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1347">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1348">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1349">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-1350" />
                </div>
                <div data-id="element-1351">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1352">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1353">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-1354">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-1355">
                הצטרפו לאימון ניסיון
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ContactSection data-id="element-1356" />
      <Footer data-id="element-1357" />
    </div>;
}